import { GetResourceResponse, RequestParameters } from "maplibre-gl";

export function stylerSetGlyphProtocol(style: any) {
   style.glyphs = "glyphs://{fontstack}/{range}.pbf"
   return style;
}

export async function GlyphProtocolHandler(params: RequestParameters, abortController: AbortController): Promise<GetResourceResponse<{}>> {
   let urlMatch = params.url.match(/.*\/\/(.*)\/(.*)/);
   let font = urlMatch?.[1] || "Poppins"; // <- Example font
   let range = urlMatch?.[2] || "0-255.pbf"; // <- Example range

   let x = await fetch(`https://mapit3.mapinfo.viamap-gms.net/v1/glyphs/${font}/${range}?token=eyJkcGZ4IjogIm1hcGl0MyIsICJyZWYiOiAiMiIsICJwYXIiOiAiIiwgInByaXZzIjogInIxWjByMEYwazZCdFdxUWNPVXlrQi95NlNVcEp2MlFiZ3lYZXRxNEhZNFhPLzNZclcwK0s5dz09In0.dH7Kx3G3oNoWriafvOLORBjPdWGRDXsevrwuVqfPsqXSROjj5MyMFw1JijnXASsOAq1LoYiMSOEQroHz9LjOgw`, { signal: abortController.signal }).catch(() => ({ status: 404 } as const));
   if (x.status == 200 && x.headers.get("Content-Type") == "application/octet-stream") {
      let data = await x.arrayBuffer();
      return { data: data };
   }

   let imageResponse = await fetch(`/mapStyles/Poppins/${range}`, { signal: abortController.signal });
   let imageData = await imageResponse.arrayBuffer();
   return { data: imageData };
}